import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import EntornoLaboral from "../Comun/EntornoLaboral";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, formatText, formatCurrency, buildEntornoLaboralProps } from "../SheetLayout";
import { moneyFormatter } from "@/services/utils/useUtils";
const BaseCotizacionCata: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const baseReguladoraCATAId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getRegulatoryBaseCATA, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getRegulatoryBaseCATA(userId, prestacionId, baseReguladoraCATAId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Base Cotización CATA"
        icon="euro"
        pills={<>
          {d.periodo && <SheetPill label="Periodo" value={formatText(d.periodo)} />}
        </>}
      />

      <SheetSection title="Datos Base Cotización CATA" icon="euro">
        <SheetGrid cols={2}>
          <SheetField label="Periodo"          value={formatText(d.periodo)} />
          <SheetField label="Base Cotización"  value={d.baseCotizacion !== undefined ? `${moneyFormatter.format(d.baseCotizacion)}` : "—"} />
        </SheetGrid>
      </SheetSection>

      {d.entornoLaboral && <EntornoLaboral {...buildEntornoLaboralProps(d)} />}
    </SheetPage>
  );
};

export default BaseCotizacionCata;
